import { googleLogout } from '@react-oauth/google'

import { Avatar } from '@/components/Avatar'
import { DropdownMenu } from '@/components/DropdownMenu'
import { useUser } from '@/hooks/useUser'
import { useToast } from '@/hooks/Toast'
import { useNavigation } from '@/hooks/useNavigation'
import { api } from '@/utils/api'

export const UserMenu = () => {
  const { user } = useUser()
  const { navigate } = useNavigation()
  const toast = useToast()

  const handleLogout = async () => {
    try {
      googleLogout()
      await api.post('/auth/logout')
      window.localStorage.removeItem('loggedIn')
      window.location.href = 'https://goto.app'
    } catch (error) {
      toast.error('Something went wrong. Try again?')
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger>
        <Avatar name={user?.name} src={user?.image} />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        {user?.hasOrgAccess && (
          <DropdownMenu.Item onClick={() => navigate('/organization/teams')}>
            Organization
          </DropdownMenu.Item>
        )}
        <DropdownMenu.Item onClick={() => navigate('/account')}>
          Account
        </DropdownMenu.Item>
        <DropdownMenu.Item onClick={handleLogout}>Sign out</DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  )
}
